import React, { useContext, useEffect, useState } from 'react';
import proyectoContext from '../../context/proyectos/proyectoContext';
import criticaContext from '../../context/criticas/criticaContext';
import { makeStyles } from "@material-ui/core/styles";
import moment from 'moment';
import Swal from 'sweetalert2';
import {
    TwitterShareButton,
    WhatsappShareButton,

    TwitterIcon,
    WhatsappIcon,
} from "react-share";


const useStyles = makeStyles({
    root: {
        maxWidth: 400
    },
    img: {
        maxWidth: 350
    },
    titulo: {
        fontWeight: 'bold',
        textAlign: 'center'
    }
});

export default function Critica({ critica }) {
    const classes = useStyles();


    // Extrar si un proyecto esta activo
    const proyectosContext = useContext(proyectoContext);
    const { proyecto } = proyectosContext;

    // obtener la función del context de critica
    const criticasContext = useContext(criticaContext);
    const { eliminarCritica, obtenerCriticas, guardarCriticaActual } = criticasContext;


    // Extraer el proyecto
    const [proyectoActual] = proyecto;

    const [fechaquelavi, guardarFechaQueLaVi] = useState();


    const [imagenapi, guardarImagenApi] = useState('/tzve3LD534wsCnhOrSqgJ1mnRma.jpg');

    const [releasemovie, guardarReleaseMovie] = useState('2020');

    // Función que se ejecuta cuando el usuario presiona el btn de eliminar critica
    const criticaEliminar = id => {

        Swal.fire({
            title: '¿Estás seguro que quieres borrar?',
            text: "Luego no podras recuperarlo...",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3c1053',
            cancelButtonColor: '#2f3848',
            confirmButtonText: 'Si, borrar.'
        }).then((result) => {
            if (result.isConfirmed) {
                eliminarCritica(id, proyectoActual._id);
                obtenerCriticas(proyectoActual.id)
                Swal.fire(
                    'Critica Borrada!',
                    'Se ha borrado con éxito.',
                    'success'
                )
            }
        })


    }


    /*  // Agrega una critica actual cuando el usuario desea editarla
     const seleccionarCritica = critica => {
         guardarCriticaActual(critica);
     } */

    const editarCritica = critica => {
        guardarCriticaActual(critica)
    }

    let nombreMayuscula = critica.nombre.slice(0, 1).toUpperCase() + critica.nombre.slice(1, critica.nombre.length)
    let detalleMayuscula = critica.detalle.slice(0, 1).toUpperCase() + critica.detalle.slice(1, critica.detalle.length)
    let espectadoresMayuscula = critica.espectadores.slice(0, 1).toUpperCase() + critica.espectadores.slice(1, critica.espectadores.length)

    // date is a Date object you got, e.g. from MongoDB
    const time = moment(critica.fechaEnVerla);
    let fechaEnVerlaFormatoCorrecto = time.format("DD/MM/YY");

    const apiKey = process.env.REACT_APP_APIKEY_MOVIE

    //tweet que va a mostrar cuando se presione el boton
    let tweet = `El ${fechaquelavi} ví la película: ${nombreMayuscula} 
    y esto es lo que me pareció: ${detalleMayuscula} le dí un puntaje de ${critica.calificacion} `

    const consultarApi = async () => {

        try {
            const api = await fetch(`https://api.themoviedb.org/3/search/movie?api_key=${apiKey}&query=${critica.nombre}`);
            const frase = await api.json();

            guardarImagenApi(frase.results[0].poster_path);
            guardarReleaseMovie(frase.results[0].release_date)

            guardarFechaQueLaVi(fechaEnVerlaFormatoCorrecto)
        } catch (error) {
            guardarImagenApi('/tzve3LD534wsCnhOrSqgJ1mnRma.jpg');
            guardarReleaseMovie('2020')
        }


    }
    useEffect(() => {

        if (proyecto) {
            consultarApi()
        }
        //eslint-disable-next-line
    }, [obtenerCriticas])

    const clickEditar = critica => {
        editarCritica(critica)
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return (
        <li className="tarea sombra">
            <div className="card_movie">
                <img className={classes.img} src={`https://image.tmdb.org/t/p/w500${imagenapi}`} alt="imagen" />
                <p className={classes.titulo}>{nombreMayuscula}({releasemovie})</p>
                <p>{detalleMayuscula}</p>
                <p>La vi el: {fechaquelavi}</p>
                <p>La vi con: {espectadoresMayuscula}</p>
                <p>Tu puntaje: {critica.calificacion}</p>
            </div>



            <div class="acciones">

                <TwitterShareButton
                    url="https://forocriticas.netlify.app/"
                    title={tweet}

                >
                    <TwitterIcon
                        size={32}
                        round
                    />
                </TwitterShareButton>

                <WhatsappShareButton
                    url="Crea tu critica en: https://forocriticas.netlify.app/"
                    title={tweet}
                    separator="- "
                >
                    <WhatsappIcon size={32} round />
                </WhatsappShareButton>
                <button
                    type="button"
                    className="btn btn-primario"
                    onClick={() => clickEditar(critica)}
                >Editar</button>

                <button
                    type="button"
                    className="btn btn-eliminar"
                    onClick={() => criticaEliminar(critica._id)}
                >Eliminar</button>



            </div>

        </li>

    );

}
